import { FlexBox } from '@ardoq/layout';
import { ViewpointToolbarContextDropdown } from './ViewpointToolbarContextDropdown';
import { ButtonSize, IconButton, TertiaryButton } from '@ardoq/button';
import { Icon, IconName } from '@ardoq/icons';
import { ViewpointToolBar } from './toViewpointToolBarProps';
import { t } from '@ardoq/i18n';
import { ViewpointSelectorButton } from './ViewpointSelectorButton';
import { ShowExcludedButton } from './ShowExcludedButton';
import { tourAnchorIds } from '@ardoq/product-tours';

const SelectionToolbar = (props: ViewpointToolBar) => {
  const {
    i18nLocale,
    contextDropdown,
    detailsButton,
    viewpointButton,
    priorityViewpointItems,
    seeAllViewpointsLabel,
    defaultOverviewLabel,
    openInInventoryButton,
    clearSelection,
    excludedComponentCount,
    isDiscover,
  } = props;
  return (
    <FlexBox
      gap="small"
      align="center"
      borderWidth={1}
      borderColor="borderFocus"
      backgroundColor="surfaceActive"
      borderRadius="medium"
      padding="xsmall"
      data-tour-id={tourAnchorIds.canvasViewpointToolbar}
    >
      <ViewpointToolbarContextDropdown
        i18nLocale={i18nLocale}
        {...contextDropdown}
      />
      <TertiaryButton
        onClick={detailsButton.onClick}
        isActive={detailsButton.isActive}
        buttonSize={detailsButton.buttonSize}
        isDisabled={detailsButton.isDisabled}
        data-tooltip-text={
          detailsButton.isDisabled
            ? detailsButton.disabledPopoverText
            : undefined
        }
      >
        <FlexBox gap="xsmall" align="center" paddingX="xsmall">
          <Icon iconName={detailsButton.iconName} />
          {detailsButton.text}
        </FlexBox>
      </TertiaryButton>
      <ViewpointSelectorButton
        viewpointButton={viewpointButton}
        priorityViewpointItems={priorityViewpointItems}
        seeAllViewpointsLabel={seeAllViewpointsLabel}
        defaultOverviewLabel={defaultOverviewLabel}
      />
      {openInInventoryButton && (
        <TertiaryButton
          onClick={openInInventoryButton.onClick}
          isActive={openInInventoryButton.isActive}
          buttonSize={openInInventoryButton.buttonSize}
          isDisabled={openInInventoryButton.isDisabled}
        >
          <FlexBox gap="xsmall" align="center" paddingX="xsmall">
            <Icon iconName={openInInventoryButton.iconName} />
            {openInInventoryButton.text}
          </FlexBox>
        </TertiaryButton>
      )}
      <ShowExcludedButton
        excludedComponentCount={excludedComponentCount}
        isDiscover={isDiscover}
        i18nLocale={i18nLocale}
      />
      <IconButton
        iconName={IconName.CLOSE}
        onClick={clearSelection}
        label={t(i18nLocale, 'canvas:contextToolbarDeselectLabel', 'Deselect')}
        buttonSize={ButtonSize.SMALL}
      />
    </FlexBox>
  );
};

export { SelectionToolbar };
